import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		if (window.matchMedia('(min-width: 768px)').matches) return

		document.querySelectorAll('.section-images-grid').forEach((sectionEl) => {
			const id = sectionEl.id
			new Swiper(sectionEl as HTMLElement, {
				modules: [Navigation],
				slidesPerView: "auto",
				spaceBetween: 4,
				navigation: {
					prevEl: `#${id} .prev`,
					nextEl: `#${id} .next`,
					disabledClass: 'btn-disabled',
				},
			})
		})
	})
}
